import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Spinner } from '../../../../../../core/services/spinner.service';
import { ConfirmationDialogComponent } from '../../../../../../shared/components/dialog/confirmation-dialog.component';
import { PATH_ROUTING } from '../../../../../../shared/enums/routing-enums';
import { Paging, RequestOption } from '../../../../../../shared/model/common.model';
import { NewsService } from '../../../../../../shared/service/news.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  requestOption: RequestOption = new RequestOption();
  dataSource = new MatTableDataSource([]);
  displayedColumns = ['checkbox', 'title', 'author', 'status', 'lastUpdated', 'action'];
  newsFormGroup: FormGroup;
  action = '';
  sortTimeoutInstance: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('checkAll') checkAll: MatCheckbox;
  constructor(
    private router: Router,
    private spinner: Spinner,
    private newsService: NewsService,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.initForm();
    this.loadDataTable(true);
  }

  initForm() {
    this.newsFormGroup = new FormGroup({
      title: new FormControl(''),
      status: new FormControl('')
    });
  }

  addNew() {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_ADD_NEWS]);
  }

  getNewsData(title?, status?) {
    if (this.checkAll && this.checkAll.checked) {
      this.checkAll.checked = false;
    }
    this.spinner.show();
    this.newsService.getAllData(this.requestOption, title, status).subscribe((res: any) => {
      this.spinner.hide();
      this.dataSource.data = res.data.content.map(item => {
        item.lastUpdated = new Date(item.lastUpdated).toLocaleString();
        item.isChecked = false;
        return item;
      });
      const rq: RequestOption = { ...this.requestOption };
      rq.pagingOptions.totalPages = res.data.totalPages;
      rq.pagingOptions.numberOfElements = res.data.numberOfElements;
      rq.pagingOptions.totalElements = res.data.totalElements;
      this.requestOption = rq;
    });
  }

  onChangeRequestOption(event) {
    this.requestOption = event;
    this.getNewsData();
  }

  public loadDataTable(gotoFirstPage?: boolean) {
    if (gotoFirstPage) {
      this.requestOption.pagingOptions = new Paging(this.requestOption.pagingOptions.size);
      this.initRequestOption();
    }
    this.getNewsData();
  }

  public initRequestOption() {
    this.requestOption.pagingOptions.totalPages = 0;
    this.requestOption.pagingOptions.numberOfElements = 0;
  }

  public deleteNews(id) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_DELETE_NEWS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.spinner.show();
        this.newsService.deleteNews(id).subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.DELETE_NEWS);
            this.getNewsData(this.newsFormGroup.controls.title.value, this.newsFormGroup.controls.status.value);
          }
        });
      }
    });
  }

  public edit(id) {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-news', id]);
  }

  public active(id, status) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: status ? MESSAGE_TOAST.CONFIRM_CHANGE_ACTIVE_NEWS : MESSAGE_TOAST.CONFIRM_CHANGE_DEACTIVE_NEWS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.spinner.show();
        this.newsService.activeNews(id, status).subscribe(res => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(status ? MESSAGE_TOAST.ACTIVATED_NEWS : MESSAGE_TOAST.DEACTIVATED_NEWS);
            this.getNewsData();
          }
        });
      }
    });

  }

  public checkedAll() {
    if (this.checkAll.checked) {
      this.dataSource.data = this.dataSource.data.map((item: any) => {
        item.isChecked = true;
        return item;
      });
    } else {
      this.dataSource.data = this.dataSource.data.map((item: any) => {
        item.isChecked = false;
        return item;
      });
    }
  }

  public checkOne(id) {
    const index = this.dataSource.data.findIndex(item => item.id === id);
    this.dataSource.data[index].isChecked = !this.dataSource.data[index].isChecked;
    if (this.checkAll.checked) {
      this.checkAll.checked = false;
      return false;
    }
    if (this.dataSource.data.filter(item => !item.isChecked).length === 0) {
      this.checkAll.checked = true;
    }
  }

  public bulkAction() {
    const data = this.dataSource.data.filter(item => item.isChecked).map(item => item.id);
    if (this.action && data.length > 0) {
      this.spinner.show();
      this.newsService.bulkActions(this.action, data).subscribe(res => {
        this.spinner.hide();
        if (res.status === 200) {
          this.toastr.success(this.action === 'delete' ? MESSAGE_TOAST.DELETE_NEWS : MESSAGE_TOAST.ACTIVATED_NEWS);
          this.getNewsData(this.newsFormGroup.controls.title.value, this.newsFormGroup.controls.status.value);
        }
      });
    }
  }

  public filter() {
    this.newsFormGroup.controls.title.value.trim();
    this.requestOption.pagingOptions.number = 0;
    this.getNewsData(this.newsFormGroup.controls.title.value, this.newsFormGroup.controls.status.value);
  }

  public sortData(sort: Sort) {
    if (this.sortTimeoutInstance) {
      clearTimeout(this.sortTimeoutInstance);
    }
    this.sortTimeoutInstance = setTimeout(() => {
      this.requestOption.pagingOptions.sort.sortBy = sort.active;
      this.requestOption.pagingOptions.sort.sortOrder = sort.direction;
      this.getNewsData(this.newsFormGroup.controls.title.value, this.newsFormGroup.controls.status.value);
    }, 500);
  }

}
